import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        // 添加事件类型
        submitMatter() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            let query = {}
            query.MatterTypeName = this.MatterTypeName
            params = Object.assign({}, params, query);
            $http.post('api/Bing/ERP_MatterTypeAdd', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.dialogClose()
                    this.$emit('reLoadType')
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Memorandum/SpecialMatter/components/addMatterType/services.js